<template>
	<div class="newRulesDetails">
		<el-form label-width='85px' class="qcFrom contentBigBox editFroms operationFrom" ref="expertInfoUpdateArr" :rules="rules"
		 :model="expertInfoUpdateArr" v-loading="loading">
			<common-title :name="'专家设置'" :icon="'iconfont iconicon-condition'" :line-type="'1'"></common-title>
			<el-row>
				<el-col :span="4" style="text-align: center;">
					<img class="headPortrait" v-if="expertInfoUpdateArr.ImageUrl == ''||expertInfoUpdateArr.ImageUrl == null" src="../../assets/images/dark/admin/icon_expertshead.png">
					<img class="headPortrait" v-else :src="expertInfoUpdateArr.ImageUrl" alt="">
					<el-upload class="upload-demo"
					action=''
					accept="image/jpeg,image/png,image/gif,image/jpg" 
					:limit="1"
					:auto-upload="true"
					:file-list="fileList"
					:on-preview="handlePictureCardPreview"
					:on-success="handleAvatarSuccess" 
					:before-upload="beforeAvatarUpload"
					:on-change="getFile"
					:on-error="handleError">
						<el-button size="small" type="primary">编辑头像</el-button>
						<div slot="tip" class="el-upload__tip">图片大小不超过1M</div>
					</el-upload>
				</el-col>
				<el-col :span="20">
					<el-row>
						<el-col :span="10">
							<el-form-item label="状态">
								<div class="exportTab marr20">
									<div class="sliderScreeningR">
										<a href="javascript:;" @click="seachTab(true)" :class="expertInfoUpdateArr.Enable?'active':''">启用</a>
										<a href="javascript:;" @click="seachTab(false)" :class="!expertInfoUpdateArr.Enable?'active':''">禁用</a>
									</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="14">
							<el-form-item label="质控上限" prop="MaxQCCount">
								<el-input size="small" class="linline"  v-model.number="expertInfoUpdateArr.MaxQCCount" @blur="resetArrNumber(expertInfoUpdateArr.MaxQCCount)" placeholder="请输入质控上限"></el-input> 例/月
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="专家姓名" prop="Name">
								<el-input size="small" v-model="expertInfoUpdateArr.Name" placeholder="请输入姓名"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="14">
							<el-form-item label="质控费用" prop="UnitPrice">
								<el-input size="small" class="linline" v-model.number="expertInfoUpdateArr.UnitPrice" @blur="resetArrNumber(expertInfoUpdateArr.UnitPrice)" placeholder="请输入质控费用"></el-input> 元/例
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="专家专业" prop="ExpertMajor">
								<el-select size="small" v-model="expertInfoUpdateArr.ExpertMajor" placeholder="请选择专业">
									<el-option v-for="item in detailsRulesParameter.ExpertMajor" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="14">
							<el-form-item label="专家职称" prop="Title">
								<el-select size="small" v-model="expertInfoUpdateArr.Title" placeholder="请选择专家职称">
									<el-option label="主任医师" value="主任医师"></el-option>
									<el-option label="副主任医师" value="副主任医师"></el-option>
									<el-option label="主治医师" value="主治医师"></el-option>
									<el-option label="住院医师" value="住院医师"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="专家来源" prop="ExpertFromType">
								<el-select size="small" v-model="expertInfoUpdateArr.ExpertFromType" placeholder="请选择来源">
									<el-option v-for="item in detailsRulesParameter.ExpertFromType" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="适用范围" prop="ExpertFromType">
									<el-col>
										<el-radio-group v-model="range" @change="rangeChange" disabled>
											<el-radio :label="1">区域</el-radio>
											<el-radio :label="2">中心</el-radio>
										</el-radio-group>
									</el-col>
									
									<el-col class="sampletime" v-if="range==1">
										<el-form-item prop="RegionGuid" :rules="range==0?rules.RegionGuid:[{ required: false}]">
											<el-select v-model="expertInfoUpdateArr.RegionGuid" value-key="UniqueId" placeholder="请选择区域" disabled size="mini" class="name">
												<el-option label="全国" value="a446dbc7-bf21-48ce-b3a5-115ff5aebcc1"></el-option>
												<el-option v-if="regionList[0]&&regionList[0].Children" v-for="item in regionList[0].Children" :key="item.UniqueId" :label="item.Name" :value="item.UniqueId">
												</el-option>
											</el-select>
										</el-form-item>
									</el-col> 
									<!-- 中心 -->
									<div v-if="range==2">
										<el-col class="sampletime">
											<el-form-item prop="HospitalGuids" :rules="range==1?rules.HospitalGuids:[{ required: false}]">
												<el-select v-model="expertInfoUpdateArr.HospitalGuids" placeholder="请选择中心" size="mini" disabled class="name">
													<el-option label="全部" value=""></el-option>
													<el-option v-if="allHospitalsData.Hospitals.length>0" v-for="item in allHospitalsData.Hospitals" :key="item.HospitalGuid" :label="item.HospitalName" :value="item.HospitalGuid">
													</el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</div>
							</el-form-item>
							<el-form-item label="来源中心" prop="SrcHospitalGuid">
								<el-select size="small" v-model="expertInfoUpdateArr.SrcHospitalGuid" filterable placeholder="请选择来源中心">
								    <el-option
								      v-for="item in allHospitalsData.Hospitals"
								      :key="item.HospitalGuid"
								      :label="item.ShortName"
								      :value="item.HospitalGuid">
								    </el-option>
								  </el-select>
							</el-form-item>
							<el-form-item label="专家分组" prop="ExpertLevelType">
								<el-select size="small" v-model="expertInfoUpdateArr.ExpertLevelType" placeholder="请选择专家分组">
									<el-option label="甲" value="0"></el-option>
									<el-option label="乙" value="1"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="14">
							<el-form-item label="擅长设备" prop="ModalityTypes">
								<el-checkbox-group v-model="expertInfoUpdateArr.ModalityTypes">
									<el-checkbox v-for="item in detailsRulesParameter.ModalityType" :key="item.text" :label="item.text" :value="item.text"></el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<el-form-item label="擅长部位" prop="BodyParts">
								<el-checkbox-group v-model="expertInfoUpdateArr.BodyParts">
									<el-checkbox v-for="item in detailsRulesParameter.BodyPart" :key="item.text" :label="item.text" :value="item.text"></el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<el-form-item label="专家简介" prop="Description">
								<el-input type="textarea" size="small" :rows="5" v-model="expertInfoUpdateArr.Description" placeholder="请输入专家简介"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row>
				<el-form-item class="footerSetUp">
					<el-button type="primary" class="bigBtn" @click="onSubmit">保存</el-button>
				</el-form-item>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import Api from '../../api/index.js'
	import axios from '@/js/api'
	import commonTitle from '../Common/commonTitle.vue'
	// import { mapState, mapActions, mapMutations} from 'vuex'

	export default {
		components: {
			commonTitle
		},
		data() {
			return {
				range:1,
				fileList: [],
				proofImage:'',
				ModalityTypes: [],
				BodyParts: [],
				action: '',
				rules: {
					Name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],

					ExpertFromType: [{
						required: true,
						message: '请选择来源',
						trigger: 'blur'
					}],
					ExpertMajor: [{
						required: true,
						message: '请选择专业',
						trigger: 'blur'
					}],
					MaxQCCount:[{required: false, message: '必须为数字',type:'number', trigger: 'blur'}],
					UnitPrice:[{required: false, message: '必须为数字',type:'number', trigger: 'blur'}],
					HospitalGuids: [{
						required: true,
						message: '请选择适用中心',
						trigger: 'change'
					}],
					RegionGuid: [{
						required: true,
						message: '请选择适用区域',
						trigger: 'change'
					}],
				},
			}
		},
		activated(){
				this.range = this.expertInfoUpdateArr.ResourceType;
				this.getAllHospitals({
					enable: -1,
					name: '',
					pageIndex:1,
					pageCount: 999999
				}).then(()=>{
					this.expertInfoUpdateArr.RegionGuid = this.expertInfoUpdateArr.RegionGuid;
				})
				this.GetRegionList().then(()=>{
					this.expertInfoUpdateArr.HospitalGuids = this.expertInfoUpdateArr.HospitalGuids;
				});
				this.GetBodyParts()
				this.GetReportModality()
		},
		computed: {
			...Vuex.mapState('managerUser', ['expertInfoUpdateArr', 'detailsRulesParameter', 'loading']),
			...Vuex.mapState('breadcrumb', ['allHospitalsData']),
			...Vuex.mapState('admin', ['regionList'])
		},

		methods: {
			...Vuex.mapMutations('managerUser', ['setLoading']),
			...Vuex.mapActions('managerUser', ['ExpertInfoUpdate']),
			...Vuex.mapActions('breadcrumb', ['getAllHospitals','GetBodyParts','GetReportModality']),
			...Vuex.mapActions('admin', ['GetRegionList']),
			rangeChange(){
				if (range == 1) {
					this.expertInfoUpdateArr.HospitalGuids = '';
				}else{
					this.expertInfoUpdateArr.RegionGuid = '';
				}
			},
			resetArrNumber(){
				
			},
			getFile(file, fileList) {
			  this.getBase64(file.raw).then(res => {
			    const params = res.split(',');
			    if (params.length > 0) {
			      this.proofImage = params[1];
				  let Formdata = new FormData();
				  let fname = file.name.toUpperCase();
				  let pos = fname.indexOf('.');
				  //获取医生列表
				  axios.ajaxPost('post', Api.api.specialist.UploadPic,{
					  ImageBase64:this.proofImage,
					  ImageFormat:fname.substr(pos+1)
				  }).then(res => {
				  	if (res.data.StatusCode == 200) {
						this.expertInfoUpdateArr.ImageUrl = res.data.ImageUrl;
				  	}
				  })
			    }
			  })
			},
			handleUploadRemove(file, fileList) {
			  this.proofImage = '';
			},
			handlePictureCardPreview(file) {
			  this.dialogImageUrl = file.url;
			  this.dialogVisible = true;
			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 1;
				let fname = file.name.toUpperCase();
				if(fname.match("JPG|PNG|JPEG") == null) {
					this.$message.error('上传图片需要JPG或者PNG格式!');
					return false;
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 1MB!');
				}
				return isLt2M;
			},
			handleAvatarSuccess(res, file) {},
			handleError(err, rawFile) {
				// this.$message.error('图片上传错误');
			},
			seachTab(type) {
				this.expertInfoUpdateArr.Enable = type;
			},
			onSubmit() {
				let ModalityTypes = this.expertInfoUpdateArr.ModalityTypes
				let BodyParts = this.expertInfoUpdateArr.BodyParts
				this.expertInfoUpdateArr.ModalityTypes = ModalityTypes.length!=0?ModalityTypes.join(','):'';
				this.expertInfoUpdateArr.BodyParts = BodyParts.length!=0?BodyParts.join(','):'';
				this.$refs.expertInfoUpdateArr.validate((valid) => {
					this.setLoading(true);
					if (valid) {
						this.ExpertInfoUpdate()
					} else {
						return false;
					}
				});
			}
		}

	}
</script>
<style lang="scss">
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";
	.headPortrait {
		width: 100px;
		height: 100px;
		border-radius: 100px;
		margin-bottom: 15px;
		@include bg-color(rightBg);
	}
	.el-upload__tip {
		color: #C4C4C4;
		margin-top: 16px;
	}
</style>
